import { YStack, XStack, Text } from 'tamagui'
import type { CodeExampleSlide as CodeExampleSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor } from './shared'

export function CodeExampleSlide({ slide }: { slide: CodeExampleSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(24px, 4vw, 60px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          style={{ fontSize: 'clamp(20px, 3vw, 40px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        <YStack
          backgroundColor="$cardBackground"
          borderRadius="$4"
          borderWidth={1}
          borderColor="$border"
          overflow="hidden"
          marginTop="$4"
        >
          <XStack
            paddingHorizontal="$4"
            paddingVertical="$2"
            borderBottomWidth={1}
            borderBottomColor="$border"
          >
            <Text fontFamily="$mono" color="$textMuted" style={{ fontSize: '11px' }}>
              {slide.language}
            </Text>
          </XStack>
          <YStack padding="$4" style={{ overflowX: 'auto' }}>
            <Text
              tag="pre"
              fontFamily="$mono"
              color="$textSecondary"
              style={{
                fontSize: 'clamp(11px, 1.2vw, 16px)',
                lineHeight: '1.6em',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                margin: 0,
              }}
            >
              {slide.code.replace(/\\n/g, '\n')}
            </Text>
          </YStack>
        </YStack>
        {slide.annotations && slide.annotations.length > 0 && (
          <YStack gap="$2" marginTop="$4">
            {slide.annotations.map((note, i) => (
              <XStack key={i} gap="$2" alignItems="flex-start">
                <Text fontFamily="$mono" color={accentColor} style={{ fontSize: 'clamp(10px, 1vw, 14px)' }}>
                  {'▸'}
                </Text>
                <Text
                  fontFamily="$mono"
                  color="$textMuted"
                  style={{ fontSize: 'clamp(10px, 1.2vw, 14px)', lineHeight: '1.4em' }}
                >
                  {note}
                </Text>
              </XStack>
            ))}
          </YStack>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
